(function () {
  'use strict';

  /**
   * The ws-custom-select directive
   *
   * Each option provided to 'custom select' requires these properties:
   * --> text -- this is what will be displayed for the given option
   * --> state -- entirely customizable, but required for elements of display, API requests, and back end processing
   * --> default: boolean  -- is it the default?
   * --> selected: boolean -- is it selected?
   *
   * TODO: Fully implement 'multi' selection
   */

  // pulled from `spacing.less` styles to support aligning the options dropdown for different-sized windows
  var WINDOW_BOUNDS = {
    SM: 768,
    MD: 992,
    LG: 1200
  };
  angular.module('wsLrs.directives').directive('wsCustomSelect', ['$document', '$window', function ($document, $window) {
    return {
      restrict: 'E',
      templateUrl: 'modules/common/directives/custom-select/custom-select.html',
      scope: {
        cfg: '=?',
        // overrides and/or values from parent scope can be passed here
        // --> currently only supported for overriding `applySelection`
        //     and defaults for `selectedOption`/`multiSelectEnabled`
        options: '=',
        // the available options
        selectOption: '&',
        // default function for selecting an option
        applySelection: '&',
        // default handler for actions to be performed upon making a
        // selection change:
        // --> can also be handled in parent scope by listening for the
        //     'SelectionChanged' event or overriding the function definition
        //     through `scope.cfg`
        selectedOption: '=',
        // the currently selected option
        isDefaultSelected: '=',
        // is the currently selected option also the default option?
        dropdownOpen: '=',
        // is the options dropdown open?
        theme: '@',
        // the theme/style of the component:
        // --> currently supports light (Data > Activities) and dark (Report
        //     Builder) themes.
        alignRight: '@',
        // controls the alignment of the options dropdown when it's open to prevent
        // clipping
        // --> for the light theme, the dropdown gets clipped very quickly on
        //     windows smaller than 1440px
        // --> the dark theme is much less sensitive to clipping, but we still
        //     support shifting the alignment for small windows
        attachedToInput: '=?' // is the toggle button visually attached to an associated input (true) as
        // in the case of Data < Activities, or does it float on its own/to the side
        // (false/default) as in the case of Report Builder?
      },
      link: function link(scope, element) {
        // function definitions
        function defaultSelected() {
          return scope.selectedOption.state === scope.options.filter(function (option) {
            return option.default;
          })[0].state;
        }
        function onClick(event) {
          // close dropdown on outside clicks
          if (!element[0].contains(event.target)) {
            scope.$apply(function () {
              scope.dropdownOpen = false;
            });
          }
        }
        function updateOptionsAlignment() {
          var windowSize = $window.innerWidth;
          if (scope.theme === 'light') {
            // window size < 1440px actually seems to be the correct bound for larger windows rather
            // than 1200; any less than that and the options appear clipped (hence the `+ 240` below)
            scope.alignRight = windowSize < WINDOW_BOUNDS.LG + 240;
          } else if (scope.theme === 'dark') {
            // the dark theme in report builder is much less sensitive to being clipped as its
            // position being much more centered.  only support realignment for SMALL (SM) windows
            scope.alignRight = windowSize <= WINDOW_BOUNDS.SM;
          }
        }

        // scope initialization & functions
        scope.selectedOption = scope.selectedOption || scope.options.find(function (opt) {
          return opt.default;
        });
        scope.multiSelectEnabled = scope.multiSelectEnabled || scope.cfg.multiSelectEnabled || false;
        scope.attachedToInput = scope.attachedToInput || false;
        scope.theme = scope.theme || 'dark';
        updateOptionsAlignment();
        scope.toggleDropdown = function () {
          scope.dropdownOpen = !scope.dropdownOpen;
        };
        scope.selectOption = function (option) {
          if (scope.multiSelectEnabled) {
            option.selected = !option.selected;
            scope.selectedOption = option;
          } else {
            option.selected = true;
            scope.selectedOption = option;
            scope.options.filter(function (opt) {
              return opt.state !== scope.selectedOption.state;
            }).forEach(function (opt) {
              return opt.selected = false;
            });
          }
          scope.isDefaultSelected = defaultSelected();
          // uncomment below line to have the dropdown close on any new selection
          // scope.dropdownOpen = false;
          scope.applySelection();
        };
        scope.applySelection = scope.cfg.applySelection || function () {
          // this function is intentionally open to being overridden in the parent
          // scope to facilitate any additional handling needs the parent may have:
          // --> the below is a placeholder that supports the original activity search toggle
          scope.cfg.activitySearchToggle = scope.selectedOption.state;
        };
        scope.selectOption(scope.selectedOption || scope.options[0]);

        // watchers and events
        $document.on('click', onClick);
        scope.$watch('selectedOption', function (newSelection) {
          // propagate an event to parent scope(s) when the selected option changes
          scope.$emit('SelectionChanged', newSelection);
        }, true);
        angular.element($window).on('resize', function () {
          // watch for $window resize events and adjust the alignment of the options
          // dropdown as appropriate
          scope.$apply(updateOptionsAlignment);
        });

        // cleanup
        scope.$on('$destroy', function () {
          angular.element($window).off('resize', updateOptionsAlignment);
          $document.off('click', onClick);
        });
      }
    };
  }]);
})();
